import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActionModel } from '../../../../../../../core/lists/_models/action.model';
import { AdditionalStepsService } from '../../../../../../../core/services/additional-steps.service';
import { TemplateService } from '../../../../../../../core/lists/_services/template.service';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  NgModel,
  Validators,
} from '@angular/forms';
import { GeneralAutocompleteComponent } from '../../../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { FormsTemplateService } from '../../../../../forms-templates/services';
import { Template } from '../../../../../forms-templates/models';
import { FormUtility } from '../../../../../../../shared/utils';
import { Category } from '../../../../../documents-management/models';
import { DocumentService } from '../../../../../documents-management/services';
import { ActivityDocumentSaveOption } from '../../../../../../../activity-tracking/enums';
import { Subscription } from 'rxjs';
import { ActivityTrackingService } from '../../../../../../../activity-tracking/services';
import { Step } from '../../../../../../../activity-tracking/models';

@Component({
  selector: 'kt-custom-mapping-editor',
  templateUrl: './custom-mapping-editor.component.html',
  styleUrls: ['./custom-mapping-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomMappingEditorComponent implements OnInit {
  private subscriptions = new Subscription();
  mapping = [];
  action: ActionModel;
  actionPayload = [];
  actionURLPayload = [];
  actionType = '';
  formFields = [];
  filteredFormFields = [];
  additionalStep: { id: any };
  formData = {};
  toValues: string[] = [];
  newToValue = '';
  subjectValue = '';
  showSubjectOptions = false;
  showCustomFieldOptions = false;
  bodyValue = '';
  showBodyOptions = false;
  templateAutocompleteCall = this.templateService.searchAllTemplates.bind(this.templateService);
  activityTemplateAutocompleteCall;
  templateInput: FormControl;
  activityTemplateInput: FormControl;
  activityStepInput: FormControl;
  activitySteps: Step[] = [];
  enableStepSelection = false;
  submitted = false;
  @ViewChild('templateAutocomplete') templateAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('activityTemplateAutocomplete')
  activityTemplateAutocomplete: GeneralAutocompleteComponent;
  @ViewChildren('model') models: QueryList<NgModel>;
  selectedField = '';
  getDocumentTemplatesAutocomplete$ = this.formsTemplateService.findTemplates.bind(
    this.formsTemplateService,
  );
  documentTemplateForm: FormGroup;
  getCategoryAutocomplete$ = this.documentService.findCategories.bind(this.documentService, {});
  documentTemplatePayload = [];
  documentURLPayload = [];
  saveByEmailFax: boolean;
  mapper;
  documentTemplateSaveOptions = [
    { label: 'Send by email', value: ActivityDocumentSaveOption.SEND_EMAIL, selected: false },
    { label: 'Send by fax', value: ActivityDocumentSaveOption.SEND_FAX, selected: false },
    {
      label: 'Save as attachment',
      value: ActivityDocumentSaveOption.UPLOAD_ATTACHMENT,
      selected: false,
    },
    {
      label: 'Save to library',
      value: ActivityDocumentSaveOption.ADD_KNOSTOS_DOCUMENT,
      selected: false,
    },
    {
      label: 'Send for signature',
      value: ActivityDocumentSaveOption.SEND_FOR_SIGNATURE,
      selected: false,
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<CustomMappingEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private additionalStepsService: AdditionalStepsService,
    private activityTrackingService: ActivityTrackingService,
    private cdr: ChangeDetectorRef,
    private formsTemplateService: FormsTemplateService,
    private templateService: TemplateService,
    private documentService: DocumentService,
    private formUtility: FormUtility,
    private formBuilder: FormBuilder,
  ) {}

  ngOnInit() {
    this.submitted = false;
    this.data.mapper =
      (this.data.mapper?.submittedValues && this.data.mode === 'create') ||
      this.data.mode === 'update'
        ? this.data.mapper
        : [];
    this.action = this.data.action;
    this.actionType = this.action?.type || '';
    if (this.actionType === 'CUSTOM_API') {
      this.actionPayload = Object.keys(this.action?.payload?.payload);
      this.actionURLPayload = Object.keys(this.action?.payload?.url_payload ?? []);
    }
    this.additionalStep = this.data.additional_step;
    this.activityTemplateAutocompleteCall =
      this.templateService.searchRelatedActivityTemplates.bind(
        this.templateService,
        this.data?.templateID,
      );
    this.additionalStepsService.searchCustomKeys(this.additionalStep?.id).subscribe((result) => {
      this.formFields = result.data;
    });
    if (this.actionType === 'CREATE_TASK') {
      this.templateInput = new FormControl(null, Validators.required);
    }
    if (this.actionType === 'MOVE_ACTIVITY_STEP') {
      this.activityTemplateInput = new FormControl(null, Validators.required);
      this.activityStepInput = new FormControl(null, Validators.required);
    }

    this.documentTemplateForm = this.formBuilder.group({
      documentTemplate: [null],
      documentCategory: [null],
      options: this.formBuilder.array([]),
      subject: [''],
      body: [''],
    });
    this.documentTemplateSaveOptions.forEach((o) => {
      (this.documentTemplateForm.get('options') as FormArray).push(new FormControl(o.selected));
    });

    if (this.data.mode === 'update') {
      switch (this.actionType) {
        case 'DOCUMENT_GENERATOR': {
          this.formsTemplateService.findAllTemplates().subscribe((templates: any) => {
            this.getDocTemplateFormControl('documentTemplate').setValue(
              templates?.data.find(
                (template: { id: any }) => template.id === this.data.mapper?.docmosis_template_id,
              ),
            );
          });
          this.documentService.findAllCategories().subscribe((categories: any) => {
            this.getDocTemplateFormControl('documentCategory').setValue(
              categories?.data.find(
                (category: { id: any }) => category.id === this.data.mapper?.document_category_id,
              ),
            );
          });
          this.displayEmailFaxDetails();
          this.getDocTemplateFormControl('subject').setValue(this.data.mapper?.subject);
          this.getDocTemplateFormControl('body').setValue(this.data.mapper?.body);
          break;
        }
        case 'CUSTOM_API': {
          const sourcePayload = Object.keys(this.data.mapper?.payload ?? {}).length
            ? this.data.mapper.payload
            : this.action?.payload?.payload ?? {};

          this.actionPayload = Object.keys(sourcePayload);

          this.actionPayload.forEach((key) => {
            this.formData[key] = sourcePayload[key];
          });
          this.actionURLPayload = Object.keys(this.data.mapper?.url_payload);
          this.actionURLPayload.forEach((urlPayload) => {
            this.formData[urlPayload] = this.data.mapper?.url_payload[urlPayload];
          });
          break;
        }
        case 'FAX':
        case 'EMAIL': {
          this.toValues = this.data.mapper?.to;
          this.subjectValue = this.data.mapper?.subject;
          this.bodyValue = this.data.mapper?.body;
          break;
        }
        case 'CREATE_TASK':
          this.templateService
            .getTemplateById(this.data.mapper?.task_template_id)
            .subscribe((result) => {
              if (result?.data && result.data[0])
                this.templateAutocomplete.setValue(result.data[0]);
            });
          break;
        case 'MOVE_ACTIVITY_STEP':
          this.activityTrackingService
            .getActivityTemplateByID(this.data.mapper?.related_activity_template_id)
            .subscribe((result) => {
              if (result?.data) {
                this.activityTemplateAutocomplete.setValue(result.data);
                this.activityStepInput.setValue(this.data.mapper?.related_activity_template_step);
              }
            });
          break;
      }
    }
    if (this.data.mapper.submittedValues === true) {
      switch (this.actionType) {
        case 'DOCUMENT_GENERATOR': {
          this.getDocTemplateFormControl('documentTemplate').setValue(
            this.data.mapper?.docmosis_template_id,
          );
          this.getDocTemplateFormControl('documentCategory').setValue(
            this.data.mapper?.document_category_id,
          );
          this.displayEmailFaxDetails();
          this.getDocTemplateFormControl('subject').setValue(this.data.mapper?.subject);
          this.getDocTemplateFormControl('body').setValue(this.data.mapper?.body);
          break;
        }
        case 'CUSTOM_API': {
          if (this.data.mapper?.payload) {
            this.actionPayload = Object.keys(this.data.mapper?.payload);
            this.actionPayload.forEach((payload) => {
              this.formData[payload] = this.data.mapper?.payload[payload];
            });
            this.actionURLPayload = Object.keys(this.data.mapper?.url_payload);
            this.actionURLPayload.forEach((urlPayload) => {
              this.formData[urlPayload] = this.data.mapper?.url_payload[urlPayload];
            });
          } else {
            this.actionPayload = Object.keys(this.action?.payload?.payload);
            this.actionURLPayload = Object.keys(this.action?.payload?.url_payload);
          }
          break;
        }
        case 'FAX':
        case 'EMAIL': {
          this.toValues = this.data.mapper?.to;
          this.subjectValue = this.data.mapper?.subject;
          this.bodyValue = this.data.mapper?.body;
          break;
        }
        case 'CREATE_TASK':
          this.templateService
            .getTemplateById(this.data.mapper?.task_template_id)
            .subscribe((result) => {
              if (result?.data && result.data[0])
                this.templateAutocomplete.setValue(result.data[0]);
            });
          break;
        case 'MOVE_ACTIVITY_STEP':
          this.activityTrackingService
            .getActivityTemplateByID(this.data.mapper?.related_activity_template_id)
            .subscribe((result) => {
              if (result?.data) {
                this.activityTemplateAutocomplete.setValue(result.data);
                this.activityStepInput.setValue(this.data.mapper?.related_activity_template_step);
              }
            });
          break;
      }
    }
    document.addEventListener('click', ($event) => {
      const menu = document.getElementById('customKeysMenu');
      const targetElement = $event.target;

      if (targetElement !== menu && menu) {
        this.showCustomFieldOptions = false;
      }
    });
    document.addEventListener('click', ($event) => {
      const menu = document.getElementById('subjectKeysMenu');
      const targetElement = $event.target;

      if (targetElement !== menu && menu) {
        this.showSubjectOptions = false;
      }
    });
    document.addEventListener('click', ($event) => {
      const menu = document.getElementById('bodyKeysMenu');
      const targetElement = $event.target;

      if (targetElement !== menu && menu) {
        this.showBodyOptions = false;
      }
    });
    this.subscriptions.add(
      this.getDocTemplateFormControl('documentTemplate').valueChanges.subscribe((value) => {
        if (value?.keys) {
          this.documentTemplatePayload = [];
          const data = JSON.parse(value.keys);
          this.documentTemplatePayload = data.map((item: { key: any }) => item.key) || [];
          if (this.data.mode === 'update') {
            this.documentTemplatePayload = Object.keys(this.data.mapper?.payload);
            this.documentTemplatePayload.forEach((payload) => {
              this.formData[payload] = this.data.mapper?.payload[payload];
            });
            this.documentURLPayload = Object.keys(this.data.mapper?.urlPayload);
            this.documentURLPayload.forEach((urlPayload) => {
              this.formData[urlPayload] = this.data.mapper?.urlPayload[urlPayload];
            });
            const optionValues = this.documentTemplateSaveOptions.map((option) =>
              this.data.mapper.options.includes(option.value),
            );
            this.getDocTemplateFormControl('options').setValue(optionValues);
          }
          this.cdr.detectChanges();
        }
      }),
    );
    this.displayEmailFaxDetails();
  }

  getTitle() {
    return 'Custom Mapping';
  }

  onSubmit() {
    this.submitted = true;
    if (this.actionType === 'FAX' || this.actionType === 'EMAIL') {
      this.dialogRef.close({
        to: this.toValues,
        subject: this.subjectValue,
        body: this.bodyValue,
        submittedValues: true,
      });
      return;
    }

    if (this.actionType === 'CUSTOM_API') {
      this.models.forEach((model) => {
        model.control.markAsTouched();
        model.control.updateValueAndValidity();
      });
      const hasEmptyUrlField = this.actionURLPayload?.some(
        (field) => !this.formData[field] || this.formData[field].trim() === '',
      );

      if (hasEmptyUrlField) {
        this.submitted = true;
        return;
      }
      const payload = {};
      this.actionPayload.forEach((field) => {
        payload[field] = this.formData[field];
      });
      const url_payload = {};
      this.actionURLPayload.forEach((field) => {
        url_payload[field] = this.formData[field];
      });
      this.dialogRef.close({
        url: this.action?.payload?.url,
        credential_id: this.action?.payload?.credential_id,
        payload,
        url_payload,
        submittedValues: true,
      });
      return;
    }
    if (this.actionType === 'CREATE_TASK') {
      if (!this.templateInput?.value) {
        this.templateAutocomplete.updateValueAndValidity();
        return;
      }
      this.dialogRef.close({
        task_template_id: this.templateInput?.value?.id,
        submittedValues: true,
      });
      return;
    }
    if (this.actionType === 'MOVE_ACTIVITY_STEP') {
      if (!this.activityTemplateInput?.value) {
        this.activityTemplateAutocomplete.updateValueAndValidity();
        return;
      }
      this.dialogRef.close({
        related_activity_template_id: this.activityTemplateInput?.value?.id,
        related_activity_template_step: this.activityStepInput?.value,
        submittedValues: true,
      });
      return;
    }
    if (this.actionType === 'DOCUMENT_GENERATOR') {
      const payload = {};
      this.documentTemplatePayload.forEach((field) => {
        payload[field] = this.formData[field];
      });

      const options = this.documentTemplateSaveOptions
        .filter((_, idx) => this.documentTemplateForm.controls.options.value[idx])
        .map((option) => option.value);
      if (this.saveByEmailFax) {
        const subjectControl = this.getDocTemplateFormControl('subject');
        const bodyControl = this.getDocTemplateFormControl('body');

        subjectControl.setValidators([Validators.required]);
        bodyControl.setValidators([Validators.required]);

        subjectControl.updateValueAndValidity();
        bodyControl.updateValueAndValidity();

        this.documentTemplateForm.markAllAsTouched();

        const hasSubjectError = !subjectControl.value || subjectControl.invalid;
        const hasBodyError = !bodyControl.value || bodyControl.invalid;

        if (hasSubjectError || hasBodyError) {
          if (!subjectControl.value) {
            subjectControl.setErrors({ required: true });
          }

          if (!bodyControl.value) {
            bodyControl.setErrors({ required: true });
          }
          return;
        }
      }

      this.dialogRef.close({
        docmosis_template_id: this.documentTemplateForm.controls.documentTemplate.value?.id,
        document_category_id: this.documentTemplateForm.controls.documentCategory.value?.id,
        payload,
        options,
        subject: this.documentTemplateForm.controls.subject.value,
        body: this.documentTemplateForm.controls.body.value,
        submittedValues: true,
      });
      return;
    }
  }

  close() {
    this.dialogRef.close();
  }

  addToValue(value?: string): void {
    const newValue = value || this.newToValue.trim();

    if (newValue && this.toValues.indexOf(newValue) === -1) {
      this.toValues.push(newValue);
      this.newToValue = '';
    }
  }

  removeToValue(value: string): void {
    const index = this.toValues.indexOf(value);
    if (index !== -1) {
      this.toValues.splice(index, 1);
    }
  }

  onEnterKeyToAddToValue(event: KeyboardEvent): void {
    event.preventDefault();
    this.addToValue();
  }

  insertOption(option: any, textareaId: string, valueKey?: string, optionsType?: string): void {
    if (!option) {
      return;
    }
    const textarea = document.getElementById(textareaId) as HTMLTextAreaElement;
    if (!textarea) {
      return;
    }
    const pointerIndex = textarea.selectionStart || 0;
    const originalText = valueKey
      ? this.formData[this.selectedField]
      : this[optionsType + 'Value'] || '';
    const textBeforePointer = originalText?.slice(0, pointerIndex);
    const textAfterPointer = originalText?.slice(pointerIndex);
    // Find the last open bracket before the pointer
    const lastOpenBracketIndexBeforeThePointer = textBeforePointer?.lastIndexOf('{', pointerIndex);
    if (lastOpenBracketIndexBeforeThePointer === -1) {
      // No open bracket found before the pointer
      return;
    }
    // Insert the selected option in the correct place
    if (valueKey) {
      this.formData[this.selectedField] =
        textBeforePointer.substring(0, lastOpenBracketIndexBeforeThePointer + 1) +
        option +
        '} ' +
        textAfterPointer;
    } else {
      this[optionsType + 'Value'] =
        textBeforePointer.substring(0, lastOpenBracketIndexBeforeThePointer + 1) +
        option +
        '} ' +
        textAfterPointer;
    }
    switch (optionsType) {
      case 'subject':
        this.showSubjectOptions = false;
        break;
      case 'custom':
        this.showCustomFieldOptions = false;
        break;
      case 'body':
        this.showBodyOptions = false;
        break;
    }
    this.cdr.detectChanges();
  }

  onKeyDown(event: KeyboardEvent, field?: string, optionsType?: string): void {
    if (event.key === '}') {
      this.showSubjectOptions = false;
      this.showCustomFieldOptions = false;
      this.showBodyOptions = false;
    }
    this.filteredFormFields = this.formFields.filter((option) =>
      option.toLowerCase().includes(this.getTerm(event).toLowerCase()),
    );
    const inputElement = event.target as HTMLInputElement;
    const input = inputElement.value;

    if (input && input[input.length - 1] === '{' && this.filteredFormFields.length > 0) {
      switch (optionsType) {
        case 'subject':
          this.showSubjectOptions = true;
          break;
        case 'custom':
          this.showCustomFieldOptions = true;
          if (field) {
            // To reposition the shared menu
            this.onFocusField(field, 'customKeysMenu');
          }
          break;
        case 'body':
          this.showBodyOptions = true;
          break;
      }
    }

    if (field) {
      this.selectedField = field;
    }
  }

  getTerm(event: any) {
    const caretPos = event.target?.selectionStart;
    const textBeforeCaret = (event.target as HTMLTextAreaElement).value.substring(0, caretPos);
    const braceIndex = textBeforeCaret.lastIndexOf('{');
    const termStartIndex = braceIndex !== -1 ? braceIndex + 1 : 0;
    return textBeforeCaret.substring(termStartIndex).trim();
  }

  onFocusField(id: string, menuId: string) {
    const field = document.getElementById(id) as HTMLElement;
    const position = this.calculateMenuPosition(field);
    const menu = document.getElementById(menuId);
    if (menu) {
      menu.style.top = position.top;
      menu.style.left = position.left;
    }
  }

  calculateMenuPosition(field: HTMLElement): { top: string; left: string } {
    const fieldRect = field.getBoundingClientRect();
    const top = fieldRect.top + fieldRect.height - 90 + 'px';
    const left = fieldRect.left + 'px';
    return { top, left };
  }

  filterTemplateFn(template: any): string {
    return template ? template.name : '';
  }

  onTemplateChange(val: any) {
    if (val) {
      this.templateInput.setValue(val);
    }
    this.templateInput.updateValueAndValidity();
  }

  filterActivityTemplateFn(template: any): string {
    return template ? template.name : '';
  }

  onActivityTemplateChange(val: any) {
    if (val) {
      this.activityTemplateInput.setValue(val);
      this.activityTemplateInput.updateValueAndValidity();
      this.activityTrackingService.getActivityTemplateSteps(val.id).subscribe((steps) => {
        this.activitySteps = steps.data;
        this.enableStepSelection = true;
        this.cdr.detectChanges();
      });
      return;
    }
    this.activitySteps = [];
    this.activityStepInput = null;
    this.enableStepSelection = false;
    this.activityTemplateInput.setValue(null);
    this.activityTemplateInput.updateValueAndValidity();
  }

  formatFormTemplate(template: Template): string {
    return template?.name?.replace(/\.[^/.]+$/, '') || '';
  }

  getDocTemplateFormControl(name: string): FormControl {
    return this.formUtility.getFormControl(this.documentTemplateForm, name);
  }

  formatCategory(category: Category): string {
    return category?.name || '';
  }

  getFormArrayControls(name: string): FormControl[] {
    return this.formUtility.getFormArrayControls(this.documentTemplateForm, name);
  }

  displayEmailFaxDetails() {
    this.getDocTemplateFormControl('options').valueChanges.subscribe((options) => {
      this.saveByEmailFax = !!options.find((optionSelected: any, idx: string | number) => {
        const optionVal = this.documentTemplateSaveOptions[idx].value;

        return (
          optionSelected &&
          (optionVal === ActivityDocumentSaveOption.SEND_EMAIL ||
            optionVal === ActivityDocumentSaveOption.SEND_FAX)
        );
      });
    });
  }
}
